module.exports = __webpack_public_path__ + "static/media/hm7.64feb9d4.PNG";